import { RouterStateSnapshot, Routes } from '@angular/router';
import { inject } from '@angular/core';
import { RouteGuardService } from "./core/services/route-guard.service";
import { BlogService } from '@app/core/services/blog.service';
import { firstValueFrom, map } from 'rxjs';
import { QuestionnaireService } from '@app/core/services/questionnaire.service';

function getTitle(pageTitle: string) {
  return `${pageTitle} | DaBay - Dialektapp Bayern`;
}

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    title: 'DaBay',
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/dashboard/dashboard.component').then(m => m.DashboardComponent)
  },
  {
    path: 'login',
    title: getTitle('Login'),
    canActivate: [
      () => inject(RouteGuardService).requireUnauthenticated()
    ],
    loadComponent: () => import('./core/auth/login/login.component').then(m => m.LoginComponent)
  },
  {
    path: 'onboarding',
    title: getTitle('Griaßdi!'),
    canActivate: [
      () => inject(RouteGuardService).canActivateOnboarding()
    ],
    loadComponent: () => import('./core/onboarding/onboarding-page/onboarding-page.component').then(m => m.OnboardingPageComponent)
  },
  {
    path: 'blog',
    children: [
      {
        path: '',
        title: getTitle('Themen & News'),
        loadComponent: () => import('./features/blog/blog-page/blog-page.component').then(m => m.BlogPageComponent)
      },
      {
        path: ':blogPostId',
        title: ({ paramMap }) => firstValueFrom(
          inject(BlogService)
            .getBlogPostDetail(parseInt(paramMap.get('blogPostId') as string))
            .pipe(
              map((blogPost) => blogPost.title)
            )
        ).then((blogPostTitle) => getTitle(blogPostTitle)),
        loadComponent: () => import('./features/blog/blog-detail-page/blog-detail-page.component').then(m => m.BlogDetailPageComponent)
      }
    ]
  },
  {
    path: 'ranking',
    title: getTitle('Rangliste'),
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/ranking/ranking-page/ranking-page.component').then(m => m.RankingPageComponent)
  },
  {
    path: 'questionnaire/:questionnaireId',
    title: ({ paramMap }) => firstValueFrom(
      inject(QuestionnaireService)
        .getQuestionnaireDetail(parseInt(paramMap.get('questionnaireId') as string))
        .pipe(
          map((questionnaire) => questionnaire.title)
        )
    ).then((questionnaireTitle) => getTitle(`Fragerunde "${questionnaireTitle}"`)),
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/questionnaire/questionnaire-page/questionnaire-page.component').then(m => m.QuestionnairePageComponent)
  },
  {
    path: 'archive',
    title: getTitle('Fragenbogenarchiv'),
    canActivate: [
      (_: any, state: RouterStateSnapshot) => inject(RouteGuardService).requireLogin(state)
    ],
    loadComponent: () => import('./features/questionnaire/questionnaire-archive-page/questionnaire-archive-page.component').then(m => m.QuestionnaireArchivePageComponent)
  },
  {
    path: 'about',
    title: getTitle('Über die App'),
    loadComponent: () => import('./features/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'faq',
    title: getTitle('FAQ'),
    loadComponent: () => import('./features/faq/faq.component').then(m => m.FaqComponent)
  },
  {
    path: '**',
    redirectTo: 'dashboard'
  }
];
